module.exports = __webpack_public_path__ + "ab6fa603e4980bba55eb3ccd1cc92e8d.jpg";